import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/decision';
import { modalOnHoldClose } from '../actions/modal'
import { modalErrorOpen } from '../actions/modalError';
import { get, post } from '../../utils/api';

/** Получение списка комментариев */
export function* getDecision({ payload }) {
  try {
    const response = yield call(
      get,
      `/decision?pieceId=${payload.pieceNumId}`
    );
    yield put(actions.getDecisionSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Получение списка решений по аттестации */
export function* getDecisionsList() {
  try {
    const response = yield call(get, '/decision/types');
    yield put(
      actions.getDecisionsListSuccess(
        response.map((item) => ({
          key: Object.keys(item)[0],
          value: item[Object.keys(item)[0]]
        }))
      )
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getDecisionsListFail());
  }
}

/** Постановка в карантин */
export function* setHoldOn({ payload }) {
  try {
    yield call(
      post,
      '/decision/hold',
      {
        pieceNumIds: payload.pieceNumIds,
        noteText: payload.noteText
      }
    );
    yield put(actions.getDecision({ pieceNumId: payload.pieceNumId }));
    yield put(actions.setHoldOnSuccess());
    yield put(modalOnHoldClose());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Сохранение решения */
export function* saveDecision({ payload }) {
  try {
    yield call(
      post,
      `/decision?decisionType=${payload.decision}&pieceId=${payload.pieceNumId}`
    );
    yield put(actions.getDecision({ pieceNumId: payload.pieceNumId }));
    yield put(actions.saveDecisionSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Отмена решения */
export function* declineDecision({ payload }) {
  try {
    yield call(
      post,
      `/decision/reject?decisionId=${payload.decisionId}`
    );
    yield put(actions.declineDecisionSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Принятие решения */
export function* acceptDecision({ payload }) {
  try {
    yield call(
      post,
      `/decision/accept?decisionId=${payload.decisionId}`
    );
    yield put(actions.acceptDecisionSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}
